import { render, staticRenderFns } from "./checkBrandDialog.vue?vue&type=template&id=2395fd68&scoped=true"
import script from "./checkBrandDialog.vue?vue&type=script&lang=js"
export * from "./checkBrandDialog.vue?vue&type=script&lang=js"
import style0 from "./checkBrandDialog.vue?vue&type=style&index=0&id=2395fd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395fd68",
  null
  
)

export default component.exports